export default __webpack_public_path__ + "static/media/faq.a2cb14b7.svg";